"use strict";

exports.__esModule = true;
exports.default = void 0;

var _constants = require("../configs/constants");

var _fontFamilyCss = _interopRequireDefault(require("./fontFamily.css.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var css = "\n  " + _fontFamilyCss.default + "\n  font-size: " + _constants.FONT_SIZE + "px;\n  font-size: var(--BlueConfigGlobalFontSize, " + _constants.FONT_SIZE + "px);\n";
var _default = css;
exports.default = _default;